import { render } from "./ReferenceUploadExelPopup.vue?vue&type=template&id=285b803e&scoped=true"
import script from "./ReferenceUploadExelPopup.vue?vue&type=script&lang=js"
export * from "./ReferenceUploadExelPopup.vue?vue&type=script&lang=js"

import "./ReferenceUploadExelPopup.vue?vue&type=style&index=0&id=285b803e&lang=scss&scoped=true"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-285b803e"]])

export default __exports__